export default __webpack_public_path__ + "static/media/bape1.281cb679.jpg";